import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list-wrapper"},[_c('div',{staticClass:"card-list"},_vm._l((_vm.items),function(user){return _c(VCard,{key:user._id},[_c(VCardTitle,[_vm._v(_vm._s(user.name))]),_c(VCardActions,[_c(VBtn,{attrs:{"icon":"","title":"remover"},on:{"click":function($event){return _vm.deteleAction(user)}}},[_c(VIcon,[_vm._v("remove")])],1)],1)],1)}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }